var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath419(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.545,
    height: 15.068,
    viewBox: "0 0 13.545 15.068",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath418"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-338.7 -155.01)",
    d: "M 0,881.3 H 595.276 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath420"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-380.54 -181.16)",
    d: "M 0,881.3 H 595.276 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath422"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 2.5e-5)",
    d: "M 0,881.3 H 595.276 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-504.26 -922.94)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 451.6 968.39)",
    d: "m0 0c0-3.131 2.539-5.67 5.67-5.67h116.11c3.133 0 5.672 2.539 5.672 5.67v65.465c0 3.133-2.539 5.67-5.672 5.67h-116.11c-3.131 0-5.67-2.537-5.67-5.67z",
    clipPath: "url(#clipPath418)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 507.39 933.51)",
    d: "m0 0c0.186-0.729 0.473-1.354 0.863-1.875 0.748-0.996 1.774-1.494 3.077-1.494 1.054 0 1.919 0.369 2.593 1.105 0.674 0.739 1.094 1.696 1.26 2.871h-1.875c-0.127-0.556-0.289-0.974-0.484-1.252-0.346-0.517-0.852-0.777-1.516-0.777-0.65 0-1.184 0.301-1.603 0.902-0.108 0.157-0.202 0.329-0.28 0.52h2.073l0.308 1.473h-2.711c-0.014 0.228-0.021 0.472-0.021 0.732 0 0.254 7e-3 0.494 0.021 0.725h2.895l0.306 1.472h-2.908c0.078 0.225 0.172 0.426 0.279 0.608 0.401 0.664 0.946 0.996 1.633 0.996 0.68 0 1.19-0.235 1.531-0.703 0.196-0.264 0.354-0.655 0.477-1.172h1.897c-0.03 0.674-0.241 1.346-0.631 2.014-0.707 1.191-1.823 1.787-3.346 1.787-1.143 0-2.084-0.444-2.82-1.332-0.495-0.592-0.844-1.325-1.047-2.198h-2.008l-0.307-1.472h2.11c-0.016-0.225-0.024-0.455-0.024-0.69 0-0.267 0.01-0.523 0.03-0.767h-1.809l-0.307-1.473z",
    clipPath: "url(#clipPath420)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 1175.1)",
    d: "m364.41 176.27h76.535v22.678h-76.535z",
    clipPath: "url(#clipPath422)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath419);
export default __webpack_public_path__ + "static/media/path419.0163a4182b6c23cf2a480963a9a1b76d.svg";
export { ForwardRef as ReactComponent };